import type { PageData } from '../../../../_metronic/helpers/utils/types';
import { getIdealImageSize } from '../../../../_metronic/helpers/utils/utils';

export const introData: PageData = [
  {
    formId: 'form1',
    heading: 'Intro Section',
    data: [
      { id: 'metaName', label: 'Meta title', type: 'input' },
      { id: 'metaContent', label: 'Meta description', type: 'input' },
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'image', label: 'Banner Image', info: getIdealImageSize(631, 451.5), type: 'image' },
      { id: 'presentedText', label: 'Presented by text', type: 'input' },
      {
        id: 'presentedImage',
        label: 'Presented by image',
        info: getIdealImageSize(102, 102),
        type: 'image'
      }
    ]
  }
];

export const programData: PageData = [
  {
    formId: 'form1',
    heading: 'Program Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'Program Cards',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'buttonText', label: 'Button text', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' },
      { id: 'icon', label: 'Icon', info: getIdealImageSize(48, 48), type: 'image' },
      { id: 'image', label: 'Banner Image', info: getIdealImageSize(411, 546), type: 'image' },
      { id: 'color', label: 'Background colour', type: 'input' }
    ]
  }
];

export const toolsData: PageData = [
  {
    formId: 'form1',
    heading: 'Tools Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'List of Tools',
    data: [
      { id: 'toolName', label: 'Tool Name', type: 'textarea' },
      { id: 'toolLink', label: 'Tool Link', type: 'textarea' }
    ]
  }
];

export const statsData: PageData = [
  {
    formId: 'formGroup1',
    heading: 'Statistics cards',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'image', label: 'Banner Image', info: getIdealImageSize(206.339, 230), type: 'image' },
      { id: 'link', label: 'Card Link', type: 'input' }
    ]
  }
];
